import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    text: 'Lee el ebook'
  }, {
    num: '2',
    text: 'Aplica ejercicios simples'
  }, {
    num: '3',
    text: 'Mejora tu memoria en días'
  }];
  return <section className="py-32 relative" data-id="element-84">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-86">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-87">
            ¿Cómo funciona?
          </h2>
          <div className="w-24 h-1 bg-cerebro-blue mx-auto rounded-full shadow-[0_0_10px_rgba(59,130,246,0.5)]" data-id="element-88"></div>
        </motion.div>

        <div className="relative" data-id="element-89">
          {/* Connecting Line */}
          <div className="hidden md:block absolute top-1/2 left-10 right-10 h-1 bg-slate-800 -translate-y-1/2 z-0" data-id="element-90">
            <motion.div className="h-full bg-gradient-to-r from-cerebro-blue to-cerebro-orange" initial={{
            width: '0%'
          }} whileInView={{
            width: '100%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            delay: 0.5,
            ease: 'easeInOut'
          }} data-id="element-91" />
          </div>

          <div className="grid md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-92">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.3
          }} className="flex flex-col items-center text-center" data-id="element-93">
                <div className="w-20 h-20 rounded-full bg-slate-900 border-4 border-slate-800 flex items-center justify-center mb-6 relative group" data-id="element-94">
                  <div className="absolute inset-0 rounded-full bg-cerebro-blue/20 blur-md opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-95"></div>
                  <span className="text-3xl font-display font-bold text-white relative z-10" data-id="element-96">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-2xl font-medium text-slate-200" data-id="element-97">
                  {step.text}
                </h3>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}